import React from "react";
import { ModalBuilder, Modal, Form } from "@redriver/cinnamon";
import { addCustomerContact } from "./actions";
import CustomerContactForm from "./CustomerContactForm";

const AddCustomerContact = ({
  renderTrigger,
  onRefresh,
  customerId,
  customerType,
  firstContact,
}) => (
  <ModalBuilder
    withForm
    submitAction={addCustomerContact}
    submitParams={{ customerId }}
    onSubmitted={onRefresh}
    renderTrigger={renderTrigger}
    initialData={{ isMain: firstContact }}
    renderModal={(modalProps, formProps) => (
      <Modal.Add {...modalProps} header="Add Contact">
        <Form {...formProps}>
          <CustomerContactForm
            customerType={customerType}
            lockPrimary={firstContact}
          />
        </Form>
      </Modal.Add>
    )}
  />
);

export default AddCustomerContact;
